import { render, staticRenderFns } from "./InputDemositeResult.vue?vue&type=template&id=2ac1dc0d&"
import script from "./InputDemositeResult.vue?vue&type=script&lang=ts&"
export * from "./InputDemositeResult.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
